import React from 'react';
import { Checkbox, Form, Space } from 'antd';
import { bool, func, number } from 'prop-types';

import Mapper from 'Src/common/components/mapper';
import I18nCustomFormatter from 'Src/common/components/i18nCustomFormatter';
import FormWrapper from '../formWrapper';
import './style.scss';

function StepOne({ totalSteps, toggleProfileSelectModal, handleSelectProfile, isProfileSelectModalOpen }) {
  return (
    <div className="mentorship-step-one">
      <FormWrapper
        totalSteps={totalSteps}
        step={1}
        header={
          <h3 className="arc-H300">
            <I18nCustomFormatter id="participation-question-label" />
          </h3>
        }>
        <Form.Item name="mentorship_type" rules={[{ required: true, message: 'Please select your preference' }]}>
          <Checkbox.Group size="large">
            <Space direction="vertical" size="middle">
              <Checkbox value="mentor">
                <I18nCustomFormatter id="want-to-be-mentor" />
              </Checkbox>
              <Checkbox value="mentee">
                <I18nCustomFormatter id="want-to-be-mentee" />
              </Checkbox>
            </Space>
          </Checkbox.Group>
        </Form.Item>
        <If condition={isProfileSelectModalOpen}>
          <Mapper
            isCompareEnabled={false}
            handleHideModal={toggleProfileSelectModal}
            isIgnoreEnabled={false}
            handleOkModal={handleSelectProfile}
            selectedItems={[]} />
        </If>
      </FormWrapper>
    </div>
  );
}

StepOne.propTypes = {
  totalSteps: number.isRequired,
  toggleProfileSelectModal: func.isRequired,
  handleSelectProfile: func.isRequired,
  isProfileSelectModalOpen: bool.isRequired,
};

export default StepOne;
